<script setup lang="ts">
import { SwiperSlide } from 'swiper/vue';
import type { NewsItemDTO } from '~/shared/api/client/news/news.dto';
import { getAuthorName } from '~/shared/lib/getAuthorName';

import { useSwiperControlsVisibility } from '~/shared/lib/useSwiperControlsVisibility';

const { $viewport } = useNuxtApp();

const props = defineProps<{
  slides: NewsItemDTO[];
}>();

const itemsCount = computed(() => props.slides.length);
const isControlVisible = useSwiperControlsVisibility(
  itemsCount,
  $viewport.breakpoint,
);

const DATA = computed(() => ({
  title: 'Читайте также',
  arrowColor: '#111111',
  borderColor: '#E8E8E8',
  backgroundColor: '#F3F3F3',
  textColor: '#111111',
  breakpoints: true,
  isControlVisible: isControlVisible.value,
}));
</script>

<template>
  <Slider v-bind="DATA">
    <SwiperSlide
      v-for="(item, key) in slides"
      :key="`sliderJournal_${key}`"
      :style="{ borderColor: DATA.borderColor }"
      :class="$style.swiperSlide"
    >
      <SliderItem
        v-bind="item"
        :id="item.id"
        :expert-url-id="item.expert_url_id"
        :text-color="DATA.textColor"
        :title="item.title"
        :subject="item.subject || null"
        :image="item.image?.photo?.file_url"
        :author="getAuthorName(item.author)"
        :type="item.type"
      />
    </SwiperSlide>
  </Slider>
</template>

<style module lang="scss">
.swiperSlide {
  width: 270px;
  height: auto;
  border-right: 1px solid;
}

@media (max-width: 767px) {
  .swiperSlide {
    border-right: none;
    width: 100%;
  }
}
</style>
